import { Component, Input } from '@angular/core';
import { DefaultFormDialogComponent } from '../../../../shared/message/dialogs/default-form-dialog.component';
import { GaValidateService } from '../../../../shared/formly/ga-validate.service';
import { TranslationService } from '../../../../shared/translation/translation.service';
import { Override } from '../../../../shared/app-decorators';
import { FormlyInputType, GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { IContact } from '../../../../../type_definitions/datatypes';
import { util } from '../../../../shared/util';
import { BPProfilesContactsDataService } from './bp-profiles-contacts-data.service';

@Component({
  selector: 'edit-contact-info-dialog',
  templateUrl: '../../../../shared/message/dialogs/default-form-dialog.html'
})
export class EditContactInfoDialogComponent extends DefaultFormDialogComponent {
  @Input() public model:IContact;
  @Input() public saving:boolean;
  @Input() public profileId:number;
  @Input() public bpCompanyId:number;

  constructor(
    private formlyService:GaFormlyService,
    private bpProfilesContactsDataService:BPProfilesContactsDataService,
    protected validateService:GaValidateService,
    protected translationService:TranslationService
  ) {
    super(validateService, translationService);
  }

  @Override(DefaultFormDialogComponent)
  public ngOnInit():void {
    super.ngOnInit();
    this.fields = this.createFields();
  }

  public save = ():void => {
    this.validateService.validateFields(this.fields, this.model, true)
      .then(() => {
        this.saveButtonBusy = true;
        this.bpProfilesContactsDataService.editContact(this.profileId, this.bpCompanyId, this.model.id, this.model)
          .then(() => {
            this.onSave.emit(this.model);
          })
          .finally(() => {
            this.saveButtonBusy = false;
          });

      })
      .catch(util.noop);
  };

  private createFields():IExtraFieldConfigurationObject[] {
    const fullWidthClass:string = 'col-sm-12';

    return [
      this.formlyService.anInput('firstname')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .build(),
      this.formlyService.anInput('lastname')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .build(),
      this.formlyService.anInput('email')
        .withInputType(FormlyInputType.EMAIL)
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .isRequired()
        .build(),
      this.formlyService.anInput('directPhone')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .build(),
      this.formlyService.anInput('officePhone')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .build(),
      this.formlyService.anInput('cellPhone')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .build()
    ];
  }
}